import React from "react"

const faq = props => <div>faq</div>

export default faq



// WEBPACK FOOTER //
// ./src/scenes/Help/pages/faq.js